import React, { useEffect, useState } from 'react';
import { calculateTimeRemaining, formatCountdown } from '../../utils/countdown';
import { Clock } from 'lucide-react';
interface CountdownTimerProps {
  targetDate: string;
  label?: string;
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
}
export function CountdownTimer({
  targetDate,
  label = 'Time Remaining',
  size = 'md',
  showIcon = true
}: CountdownTimerProps) {
  const [timeRemaining, setTimeRemaining] = useState(calculateTimeRemaining(targetDate));
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeRemaining(calculateTimeRemaining(targetDate));
    }, 1000);
    return () => clearInterval(timer);
  }, [targetDate]);
  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-2xl font-bold'
  };
  if (timeRemaining.total <= 0) {
    return null;
  }
  return <div className={`flex items-center space-x-2 ${sizeClasses[size]}`} data-id="element-191">
      {showIcon && <Clock className="h-4 w-4 text-red-600" data-id="element-192" />}
      <span className="text-gray-600" data-id="element-193">{label}:</span>
      <span className="font-semibold text-red-600" data-id="element-194">
        {formatCountdown(timeRemaining)}
      </span>
    </div>;
}